import Client from "src/http/client";//devour
import Deserializer from "./deserializer";
import ModelFactory from "./factory";
import vuex from "src/vuex"

export default class Model {
  /**
   * Construtor define o recurso JSON:API no cliente
   */
  constructor(attributes) {
    Client.define(this.resourceName(), this.fields(), this.options());

    if (attributes) {
      this.fill(attributes);
    }
  }

  /**
   * O nome do campo da chave primária
   * @returns {string}
   */
  primaryKey() {
    return "id";
  }

  /**
   * O nome do recurso JSON:API
   */
  resourceName() {
    throw new Error("You have to implement the method resourceName!");
  }

  /**
   * Os campos que esta model possui
   */
  fields() {
    throw new Error("You have to implement the method fields!");
  }

  /**
   * Método retorna uma nova instância da model
   * @param attributes
   * @returns {*}
   */
  new(attributes) {
    return ModelFactory.instantiateByResourceName(this.resourceName(), {
      attributes
    });
  }

  /**
   * Método altera atributos da model
   * @param attributes
   * @returns {Model}
   */
  fill(attributes) {
    Client.models[this.resourceName()].attributes = attributes;
    Object.assign(this, attributes);
    return this;
  }

  /**
   * Opções devour
   * @returns {{deserializer: (function(*=, *=): *)}}
   */
  options() {
    return {
      deserializer: (data, include) => this.deserialize(data, include)
    };
  }

  /**
   * Retorna os dados deserializados
   * @param data
   * @param include
   * @returns {*}
   */
  deserialize(data, include) {
    return new Deserializer(this, data).deserialize(include);
  }

  /**
   * Método aplica middleware nas requisições
   * @param callback
   * @param options
   * @returns {Promise<*>}
   */
  async middleware(callback, options) {
    let uuid = require("uuid/v4")();
    let promise = callback();

    this.beforeFetch(uuid, options);
    promise.then(payload => {
      this.afterFetch(uuid, options, payload);
    });
    return promise;
  }

  /**
   * Método executado antes de disparar requisições
   */
  beforeFetch(uuid, options) {
    if (options.shouldTriggerLoading !== false) {
      vuex.dispatch("startApiLoading", uuid);
    }
  }

  /**
   * Método executado após disparar requisições
   *
   * @param payload
   */
  afterFetch(uuid, options, payload) {
    if (options.shouldTriggerLoading !== false) {
      vuex.dispatch("finishApiLoading", uuid);
    }
  }

  /**
   * Método consulta API de listagem
   *
   * @param parameters
   * @returns {Promise<*>}
   */
  async findAll(parameters, options = {}) {
    return this.middleware(
      () => Client.findAll(this.resourceName(), parameters),
      options
    );
  }

  /**
   * Método consulta API de paginação
   *
   * @param pageNumber
   * @param size
   * @param parameters
   * @param options
   * @returns {Promise<*>}
   */
  async paginate(pageNumber = 1, size = 20, parameters = {}, options = {}) {
    parameters.page = {
      number: pageNumber,
      size
    };
    return this.findAll(parameters, options);
  }

  /**
   * Método consulta API de listagem por identificador
   *
   * @param id
   * @param params
   * @param options
   * @returns {Promise<*>}
   */
  async find(id, params = {}, options = {}) {
    return this.middleware(
      () => Client.find(this.resourceName(), id, params),
      options
    );
  }

  /**
   * Método acessa API de criação de entidade
   *
   * @param payload
   * @param params
   * @param meta
   * @param options
   * @returns {Promise<*>}
   */
  async create(payload, params = {}, meta = {}, options = {}) {
    return this.middleware(
      () => Client.create(this.resourceName(), payload, params, meta),
      options
    );
  }

  /**
   * Método acessa API de atualização de entidade
   *
   * @param payload
   * @param params
   * @param meta
   * @param options
   * @returns {Promise<*>}
   */
  async update(payload, params = {}, meta = {}, options = {}) {
    return this.middleware(
      () => Client.update(this.resourceName(), payload, params, meta),
      options
    );
  }

  /**
   * Método acessa API de remoção de entidade
   *
   * @param id
   * @param options
   * @returns {Promise<*>}
   */
  async destroy(id, options = {}) {
    return this.middleware(
      () => Client.destroy(this.resourceName(), id),
      options
    );
  }

  /**
   * Método acessa API de remoção em massa de entidades
   *
   * @param resources
   * @param options
   * @returns {Promise<*>}
   */
  async massDestroy(resources, options = {}) {
    return this.middleware(
      () => this.request(this.resourceName(), "DELETE", {}, resources),
      options
    );
  }

  /**
   * Método realiza uma requisição para um endpoint customizado
   *
   * @param endpoint
   * @param method
   * @param params
   * @param payload
   * @param meta
   * @param options
   * @returns {*}
   */
  async request(endpoint, method, params, payload, meta, options = {}) {
    return this.middleware(
      () =>
        Client.runMiddleware({
          method: method,
          url: Client.apiUrl + "/" + endpoint,
          model: this.resourceName(),
          data: payload,
          params: params,
          meta: meta
        }),
      options
    );
  }

  async cancelRequest() {
    Client.cancel();
    vuex.dispatch("finishLoadingWithError");
  }

  /**
   * Método retorna "Resource Identifier Object"
   * @returns {{id: *, type: void}}
   */
  toRelationship() {
    return {
      id: this.id,
      type: this.resourceName()
    };
  }
}
